import { useEffect } from "react";

export const DEFAULT_TITLE = "PRONET | Photographers Network";
export const DEFAULT_DESCRIPTION = "Find photographers, videographers and creative professionals with PRONET Pro IDs across India.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets document.title, meta description, Open Graph tags and canonical URL
 * for the current page. Skip `title`/`description` (leave undefined) while
 * data is still loading — the previous page's tags stay put until real
 * content is ready, which beats flashing a placeholder.
 */
export function useSeo({ title, description, image, path, noindex = false } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description || DEFAULT_DESCRIPTION);
    upsertMeta("property", "og:title", title || DEFAULT_TITLE);
    upsertMeta("property", "og:description", description || DEFAULT_DESCRIPTION);
    upsertMeta("property", "og:type", "website");
    if (image) upsertMeta("property", "og:image", image);

    const url = `${window.location.origin}${path || window.location.pathname}`;
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, image, path, noindex]);
}
